import {
    Button,
    Loading,
    StyleFunction,
    Surface,
    Table,
    useThemedStyle,
} from "@venuepos/react-common";
import { useGetProduct2ViProduct2MeasurementUnitQuery } from "graphql-sdk";
import React from "react";
import { useTranslation } from "react-i18next";
import { StyleProp, View } from "react-native";
import { useViModal } from "./modal";

export type Props = {
    style?: StyleProp<any>;
    productId: string;
};

export function ViProduct(props: Props) {
    const [t] = useTranslation();
    const viModal = useViModal();
    const styles = useThemedStyle(styleFunc);

    const { data, loading, refetch } =
        useGetProduct2ViProduct2MeasurementUnitQuery({
            variables: {
                productId: props.productId,
            },
            fetchPolicy: "no-cache",
        });

    return (
        <Surface style={props.style}>
            <View>
                {loading ? (
                    <Loading />
                ) : (
                    <Table>
                        <Table.Header>
                            <Table.Title>
                                {t(
                                    "backoffice.product.vi.inventory_products.title",
                                    "Inventory products"
                                )}
                            </Table.Title>
                        </Table.Header>
                        {data?.getProduct2ViProduct2MeasurementUnit.map(
                            (itr, index) => {
                                return (
                                    <Table.Row
                                        key={`product2viProduct2MeasurementUnit_list_${index}`}
                                        style={
                                            itr.deletedAt
                                                ? styles.deletedRelation
                                                : undefined
                                        }
                                    >
                                        <Table.Cell>
                                            {itr.viProduct.name}
                                        </Table.Cell>
                                        <Table.Cell>{`${itr.value} ${itr.measurementUnit.name}`}</Table.Cell>
                                    </Table.Row>
                                );
                            }
                        )}
                    </Table>
                )}
            </View>
            <Button
                onPress={() => {
                    viModal({
                        productId: props.productId,
                        onSave: () => {
                            refetch();
                        },
                    });
                }}
            >
                {t(
                    "backoffice.product.vi.setup_button",
                    "Setup inventory product"
                )}
            </Button>
        </Surface>
    );
}

const styleFunc: StyleFunction = theme => ({
    deletedRelation: {
        backgroundColor: theme.colors.semiTransparentError,
    },
});
